export const stageConstants = {
    SET_STAGES: 'SET_STAGES',
    UPDATE_STAGE: 'UPDATE_STAGE',
    UPDATE_STAGES_CARD_COUNT: 'UPDATE_STAGES_CARD_COUNT',
    STAGE_SORT: 'STAGE_SORT',
    CARD_SORT: 'CARD_SORT',
    SORT_STAGE_AND_CARDS: 'SORT_STAGE_AND_CARDS',
    REFRESH_STAGE: 'REFRESH_STAGE',
    STAGE_SORT_CARD_DUE_DATE: 'STAGE_SORT_CARD_DUE_DATE',
    REVERT_STAGES: 'REVERT_STAGES',
    
    ADD_ITEM_TO_STAGE: 'ADD_ITEM_TO_STAGE',
    ADD_ITEMS_TO_STAGE: 'ADD_ITEMS_TO_STAGE',
    REMOVE_ITEM_FROM_STAGE: 'REMOVE_ITEM_FROM_STAGE',

    STAGES_TO_RELOAD: 'STAGES_TO_RELOAD', // Stages to reload. Used when a card is moved to a stage that is not in the current view
}

export const NEW_STAGE_MODAL_ACTIONS = {
    OPEN_NEW_STAGE_MODAL: 'OPEN_NEW_STAGE_MODAL',
    CLOSE_NEW_STAGE_MODAL: 'CLOSE_NEW_STAGE_MODAL',
}

export const STAGE_MESSAGE = {
    DELETE_STAGE_TITLE: 'Delete Stage',
    DELETE_STAGE_CONFIRM_TEXT: 'Delete Stage',
    DELETE_STAGE_MESSAGE: 'Deleting this stage will also move all the cards in it to the Recycle Bin and will be permanently deleted after 30 days.'
};